export const closeWindow = (key) => {
    return {
        type: "close",
        key: key
    }
}


export const openWindow = (key) => {
    return {
        type: "open",
        key: key
    }
}

export const closeAllApps = (key) => {
    return {
        type: "closeAllApps",
        key: key
    }
}


export const flipState = (key) => {
    return {
        type: "flipState",
        key: key
    }
}

export const turnOffDrag = () => {
    return {
        type: "turnOffDrag",
    }
}
export const turnOnDrag = () => {
    return {
        type: "turnOnDrag",
    }
}


export const handleToggleTaskView = () => {
    return {
        type: "toggleTaskView",
    }
}

export const handleEnableTaskView = () => {
    return {
        type: "enableTaskView",
    }
}

export const handleDisableTaskView = () => {
    return {
        type: "disableTaskView",
    }
}